import React from 'react';

import PropTypes from 'prop-types';
import styled from 'styled-components';

import { breakpoint } from '@constants/styles';
import { Icon, Divider } from '@components';
import { useBreakpoints } from '@hooks/NewBreakpoint';

export const NAV_BAR_WIDTH_AT_LARGE = 216;

const NavBar = styled.div`
  padding-bottom: 16px;
  overflow: hidden;
  background-image: linear-gradient(180deg, #4291da, #0f6cce);
  border-radius: 0 10px 0 0;
  transition: width 225ms cubic-bezier(0.4, 0, 0.6, 1) 0ms;
  position: fixed;
  height: 100%;
  z-index: 3;
  width: ${({ isOpen }) => (isOpen ? `256px` : `0px`)};
  ${breakpoint('large')`
    overflow-y: hidden  ;
    position: relative;
    height: auto;    
    width: ${NAV_BAR_WIDTH_AT_LARGE}px;
  `}
  :hover {
    overflow-y: auto;
  }
`;

const NavBarAction = styled.div`
  ${({ isSmall }) => isSmall && ` margin-bottom: 25px;`}
  display: flex;
  flex-direction: row;
  padding-top: 24px;
  padding-bottom: 16px;
  padding-left: 16px;
  padding-right: 16px;
  text-align: right;
  width: 100%;
  justify-content: space-between;
  align-items: center;  
  ${breakpoint('large')`
      padding-top: 16px;
    `}
  }
  > .close {
    cursor: pointer;    
    ${breakpoint('large')`
      display: none !important;
    `}
  }
  > .arrow {
    cursor: pointer;
    display: none !important;
    position: relative;
    left: ${({ isOpen }) => (isOpen ? `170px` : `20px`)};
    transition: all 225ms cubic-bezier(0.4, 0, 0.6, 1) 0ms;
    transform: rotate(0deg);
    &.expand {
      transform: rotate(180deg);
    }
    ${breakpoint('large')`
      display: block !important;
    `}
  }
  > .logo {
    color: #fff;    
    ${breakpoint('large')`
      display: none !important;
      flex-direction: column;      
    `}
  }
`;

const Logo = styled.div`
  margin-bottom: 25px;
  padding: 0 ${({ isOpen }) => (isOpen ? `24px` : `16px`)};
  transition: all 225ms cubic-bezier(0.4, 0, 0.6, 1) 0ms;
  display: none;
  ${breakpoint('large')`
    display: block;
  `}
`;

const Links = styled.div`
  overflow-y: auto;
  overflow-x: hidden;
  height: calc(100vh - 98px);
  padding-bottom: 16px;
  ::-webkit-scrollbar {
    width: 10px;
    border-radius: 0 10px 0 0;
  }
  ::-webkit-scrollbar-track {
    width: 10px;
    border-radius: 0 10px 0 0;
  }
  ::-webkit-scrollbar-thumb {
    background: #888;
    border-radius: 5px;
  }
  ::-webkit-scrollbar-thumb:hover {
    background: #555;
    border-radius: 5px;
  }
  ${({ isSmall }) =>
    isSmall &&
    `
    height: calc(100vh - 159px);
  `}
`;

const Merchant = styled.div`
  ${breakpoint('large')`    
  `}
  display: block;
  flex-direction: column;
  width: 100%;
`;

const MerchantName = styled.div`
  font-size: 12px;
  padding: 16px 16px;
  color: #f8f8f8;
  text-overflow: ellipsis;
  line-height: 14px;
  text-transform: capitalize;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  max-width: 180px;
  overflow: hidden;
  max-height: 46px;
`;

const IconNameBox = styled.div`
  display: flex;
  padding: 0 10px 0 25px;
  align-items: center;
  margin-bottom: 16px;
`;
const IconBox = styled.div`
  display: flex;
  width: 20px;
`;

const DividerStyled = styled(Divider)`
  width: 85%;
  height: 0;
  border: solid 1px #e4e6eb1f;
  border-width: thin;
  margin: 10px auto;
`;

const SideBar = ({ children, isOpen, setIsOpen, merchant }) => {
  const { breakpoint: breakpointHook } = useBreakpoints();

  const isSmall = ['xs', 'sm', 'ss', 'smm', 'll', 'md'].includes(breakpointHook);
  return (
    <>
      <NavBar isOpen={isOpen} style={{ overflow: 'hidden' }}>
        {isSmall ? (
          <NavBarAction
            id="sidebar_action"
            isOpen={isOpen}
            onClick={() => setIsOpen(!isOpen)}
            isSmall={isSmall}
          >
            <Icon
              className="logo"
              style={{ width: '72px', height: '30px', marginLeft: '12px' }}
              icon="logo"
              color="#FFF"
            />
            <Icon className="close" icon="close" size="24" color="#FFF" />
          </NavBarAction>
        ) : (
          <NavBarAction id="sidebar_action" isOpen isSmall={isSmall}>
            <Icon
              className="logo"
              style={{ width: '72px', height: '30px', marginLeft: '12px' }}
              icon="logo"
              color="#FFF"
            />
          </NavBarAction>
        )}
        <Logo isOpen={isOpen}>
          <Icon
            icon="logo"
            style={{
              height: '35px',
              width: '72px',
            }}
            color="#FFF"
          />
        </Logo>
        {isSmall && (
          <Merchant>
            <IconNameBox>
              <IconBox>
                <Icon className="user" size="20" icon="user" color="#f8f8f8" />
              </IconBox>
              <MerchantName>
                {merchant.merchant_name !== '' ? merchant.merchant_name : merchant.business_name}
              </MerchantName>
            </IconNameBox>
            <DividerStyled />
          </Merchant>
        )}
        <Links isSmall={isSmall}>{children}</Links>
      </NavBar>
    </>
  );
};

SideBar.propTypes = {
  children: PropTypes.array.isRequired,
  isOpen: PropTypes.bool.isRequired,
  setIsOpen: PropTypes.func.isRequired,
};

export default SideBar;
